import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var UserInput = styled.div.withConfig({
  displayName: "partials__UserInput",
  componentId: "sc-ofacj-0"
})(["width:100%;padding:9px 12px;border:1px solid ", ";border-radius:", ";box-shadow:0 1px 2px rgb(0 0 0 / 0.05);font-family:", ";font-size:1rem;line-height:1.5;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiM;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily;
}, getFont(0, 'default'));
export var ReviewBlock = styled.div.withConfig({
  displayName: "partials__ReviewBlock",
  componentId: "sc-ofacj-1"
})(["margin-bottom:60px;", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 30px;\n  "]))));
export var RatingLabel = styled.span.withConfig({
  displayName: "partials__RatingLabel",
  componentId: "sc-ofacj-2"
})(["margin-left:18px;", ";line-height:40px;", ";"], getFont(0, 'default'), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    margin-left: 0;\n    height: 40px;\n  "]))));
export var Features = styled.div.withConfig({
  displayName: "partials__Features",
  componentId: "sc-ofacj-3"
})(["", ";> div{width:100%;", ";}"], minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n  "]))), minMediaQueries.tablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      width: 50%;\n    "]))));
export var Label = styled.div.withConfig({
  displayName: "partials__Label",
  componentId: "sc-ofacj-4"
})(["display:block;height:40px;margin-bottom:16px;font-weight:700;", ";", ";"], getFont(2, 'default'), maxMediaQueries.phone(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(1, 'compact')));
export var LabelSmall = styled.span.withConfig({
  displayName: "partials__LabelSmall",
  componentId: "sc-ofacj-5"
})(["", ";font-weight:300;"], getFont(0, 'default'));
export var Hint = styled.div.withConfig({
  displayName: "partials__Hint",
  componentId: "sc-ofacj-6"
})(["color:", ";", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.fontLL;
}, getFont(-1, 'compact'));
export var LegalDisclaimer = styled(Paragraph).withConfig({
  displayName: "partials__LegalDisclaimer",
  componentId: "sc-ofacj-7"
})(["", ";"], getFont(-1, 'default'));